// extracted by mini-css-extract-plugin
module.exports = {"postMeta":"PostMeta-module--postMeta--2zi62"};